import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/policy-library.scss";

const interpolate = (value, brandName, email) =>
  value
    .replace(/\{brand\}/g, brandName)
    .replace(/\{email\}/g, email || "customer care");

function PolicyDocument({ policy }) {
  const brandName = siteConfig.brandName;
  const contact = siteConfig.contact || {};
  const lastUpdated = siteConfig.policyLastUpdated || "16 October 2026";

  return (
    <main className="content-page legal-page policy-document-page">
      <header className="page-hero page-hero--compact">
        <div className="page-shell page-hero__content">
          <p className="eyebrow">{policy.eyebrow}</p>
          <h1>{policy.title}</h1>
          <p className="page-hero__lede">{policy.description}</p>
          <p className="policy-document-page__updated">
            Last updated: {lastUpdated}
          </p>
        </div>
      </header>

      <section className="page-section page-shell legal-layout">
        <nav className="policy-nav" aria-label={`${policy.title} sections`}>
          <p className="eyebrow">Contents</p>
          {policy.sections.map((section) => (
            <a key={section.id} href={`#${section.id}`}>
              {section.title}
            </a>
          ))}
          <a href="#policy-contact">Contact</a>
        </nav>

        <article className="prose legal-copy">
          <div className="policy-document-page__notice" role="note">
            This policy explains the current {brandName} approach. It does not
            exclude, restrict, or modify a right or remedy that cannot lawfully
            be excluded.
          </div>

          {policy.sections.map((section, index) => (
            <section id={section.id} key={section.id}>
              <h2>
                {index + 1}. {section.title}
              </h2>
              {(section.paragraphs || []).map((paragraph) => (
                <p key={paragraph}>
                  {interpolate(paragraph, brandName, contact.email)}
                </p>
              ))}
              {section.bullets && (
                <ul>
                  {section.bullets.map((bullet) => (
                    <li key={bullet}>
                      {interpolate(bullet, brandName, contact.email)}
                    </li>
                  ))}
                </ul>
              )}
            </section>
          ))}

          <section id="policy-contact">
            <h2>{policy.sections.length + 1}. Contact</h2>
            <p>
              Questions, requests, or concerns about this policy can be sent
              through our <Link to="/contact">contact page</Link>
              {contact.email && (
                <>
                  {" "}or by email to{" "}
                  <a href={`mailto:${contact.email}`}>{contact.email}</a>
                </>
              )}
              .
            </p>
            {contact.address && <address>{contact.address}</address>}
            <p className="policy-document-page__backlink">
              <Link to="/policies">View all store policies</Link>
              {" · "}
              <Link to="/privacy">Privacy policy</Link>
              {" · "}
              <Link to="/terms">Terms &amp; conditions</Link>
            </p>
          </section>
        </article>
      </section>
    </main>
  );
}

export default PolicyDocument;
